@if (offer) {
  <div class="d-flex flex-column">
    @if (
      selectCommodity(offer, energyType.ELECTRICITY);
      as electricityOverview
    ) {
      <essent-commodity-offer-product-breakdown-row
        [description]="content?.electricityLabel"
        [value]="electricityOverview.totalPrice.expectedYearlyAmount"
      ></essent-commodity-offer-product-breakdown-row>
    }
    @if (selectCommodity(offer, energyType.GAS); as gasOverview) {
      <essent-commodity-offer-product-breakdown-row
        [description]="content?.gasLabel"
        [value]="gasOverview.totalPrice.expectedYearlyAmount"
      ></essent-commodity-offer-product-breakdown-row>
    }
    @if (offer.expectedYearlyAmount) {
      <wl-essent-sme-commodity-offer-price-breakdown-row
        [description]="yearlyCostsLabel(offer)"
        [discountDescription]="content?.cashbackLabel"
        textStyle="bold"
        [value]="offer.expectedYearlyAmount"
        [discountValue]="offer.discountPrice"
      ></wl-essent-sme-commodity-offer-price-breakdown-row>
    }
    @if (content?.offerSubmitDescriptionLabel) {
      <p class="mt-2">
        <span class="description">{{
          content?.offerSubmitDescriptionLabel
        }}</span>
        @if (!!content?.offerSubmitDescriptionTooltip) {
          <wl-tooltip
            [tooltip]="{ description: content?.offerSubmitDescriptionTooltip }"
          ></wl-tooltip>
        }
      </p>
    }
  </div>
}
